export default {
  hint: 'Confirma el pago con tu banco para finalizar tu pedido.',
  cancel: 'Cancelar pago',
};
